import { TableRow as MUITableRow, styled } from '@mui/material';
export default styled(MUITableRow)(({ theme }) => ({
    '&:not([data-header="true"])': {
        '&:last-child td, &:last-child th': {
            border: 0,
        },
    },
}));
